const overrides = (palette, typography) => ({
  separator: {
    marginLeft: 4,
    marginRight: 4
  }
})

export default overrides
